




































const isElement = (x: any): x is HTMLInputElement =>
  x instanceof HTMLInputElement;

import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { CookieHelper } from "@/helper/cookieHelper";
import { DateHelper } from "@/helper/dateHelper";


@Component({
  components: {
  }
})

export default class DeletePage extends Vue {
  @Prop() private link! : string

    mounted()
    {
        // モーダル表示モード: ON
        this.$store.getters.applicationState.modalMode = 1;
    }

    destroyed()
    {
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
    }
    
    onDelete(){
        this.$emit("close");
        this.$emit("onClickPageDeleteButton");
    }

    //configcolor
    private get userConfigColors(){
        return this.$store.getters.userConfigColors;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        }
    }
}
